import { render, staticRenderFns } from "./DialogPageMessageTemplates.vue?vue&type=template&id=a673de0c"
import script from "./DialogPageMessageTemplates.vue?vue&type=script&lang=js"
export * from "./DialogPageMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports